// New localized error message keys
export enum ErrorMessageKey {
  INVALID_BOT_TOKEN = 'messages.INVALID_BOT_TOKEN',
  NOT_SUPPORTED_PAYMENT_TYPE = 'messages.NOT_SUPPORTED_PAYMENT_TYPE',
  DELIVERY_ON_TIME_NOT_SUPPORTED = 'messages.DELIVERY_ON_TIME_NOT_SUPPORTED',
  TAKEOUT_ON_TIME_NOT_SUPPORTED = 'messages.TAKEOUT_ON_TIME_NOT_SUPPORTED',
  TELEGRAM_USERNAME_REQUIRED = 'messages.TELEGRAM_USERNAME_REQUIRED',
  INVALID_STAFF_MEMBER_UPDATE = 'messages.INVALID_STAFF_MEMBER_UPDATE',
  INVALID_STAFF_MEMBER_REMOVE = 'messages.INVALID_STAFF_MEMBER_REMOVE',
  CHAIN_NOT_FOUND = 'messages.CHAIN_NOT_FOUND',
  NOT_ALLOWED_TO_CREATE_CHAIN = 'messages.NOT_ALLOWED_TO_CREATE_CHAIN',
  LOCATION_NOT_FOUND = 'messages.LOCATION_NOT_FOUND',
  LOCATION_NOT_CONFIGURED = 'messages.LOCATION_NOT_CONFIGURED',
  DELIVERY_ZONE_NOT_FOUND = 'messages.DELIVERY_ZONE_NOT_FOUND',
  INVALID_ACTION = 'messages.INVALID_ACTION',
  UNAUTHORIZED_CHAIN_ACCESS = 'messages.UNAUTHORIZED_CHAIN_ACCESS',
  INTERNAL_ERROR = 'messages.INTERNAL_ERROR',
  MENU_ITEM_NOT_FOUND = 'messages.MENU_ITEM_NOT_FOUND',
  MENU_ITEM_OUT_OF_STOCK = 'messages.MENU_ITEM_OUT_OF_STOCK',
  ORDER_NOT_FOUND = 'messages.ORDER_NOT_FOUND',
  STAFF_MEMBER_NOT_FOUND = 'messages.STAFF_MEMBER_NOT_FOUND',
  STAFF_MEMBER_DUPLICATION_CONFLICT = 'messages.STAFF_MEMBER_DUPLICATION_CONFLICT',
  MENU_CATEGORY_NOT_FOUND = 'messages.MENU_CATEGORY_NOT_FOUND',
  MENU_CATEGORY_WITH_ITEMS_CANNOT_BE_REMOVED = 'messages.MENU_CATEGORY_WITH_ITEMS_CANNOT_BE_REMOVED',
  INVALID_INPUT = 'messages.INVALID_INPUT',
  INVALID_TELEGRAM_INIT_DATA = 'messages.INVALID_TELEGRAM_INIT_DATA',
  INVALID_HEADERS = 'messages.INVALID_HEADERS',
  EMPTY_CODE = 'messages.EMPTY_CODE',
  DATABASE_ERROR = 'messages.DATABASE_ERROR',
  INSUFFICIENT_PERMISSIONS = 'messages.INSUFFICIENT_PERMISSIONS',
  LOCATION_NOT_WORKING = 'messages.LOCATION_NOT_WORKING',
  ONLINE_PAYMENT_MAX_ATTEMPTS_EXCEEDED = 'messages.ONLINE_PAYMENT_MAX_ATTEMPTS_EXCEEDED',
  MAX_WAITING_ORDERS_NUMBER_EXCEEDED = 'messages.MAX_WAITING_ORDERS_NUMBER_EXCEEDED',
  MENU_VARIATION_NOT_FOUND = 'messages.MENU_VARIATION_NOT_FOUND',
  MENU_VARIATION_GROUP_NOT_FOUND = 'messages.MENU_VARIATION_GROUP_NOT_FOUND',
  INVALID_VARIATION_MENU_ITEM = 'messages.INVALID_VARIATION_MENU_ITEM',
  LOCATION_IS_CLOSED = 'messages.LOCATION_IS_CLOSED',
  CHAIN_CUTLERY_SETTINGS_DISABLED = 'messages.CHAIN_CUTLERY_SETTINGS_DISABLED',
  DELIVERY_NOT_AVAILABLE_TO_ADDRESS = 'messages.DELIVERY_NOT_AVAILABLE_TO_ADDRESS',
  YOOKASSA_NO_RECEIPTS_DATA = 'messages.YOOKASSA_NO_RECEIPTS_DATA',
  FETCH_FAILED = 'messages.FETCH_FAILED',
  KASSA_INVALID_CURRENCY = 'messages.KASSA_INVALID_CURRENCY',
  INVALID_DATE = 'messages.INVALID_DATE',
  LEGAL_DOCUMENT_NOT_FOUND = 'messages.LEGAL_DOCUMENT_NOT_FOUND',
  USER_NOT_FOUND = 'messages.USER_NOT_FOUND',
  CHAIN_HAS_NOT_SIGNED_OWNER_DOCUMENTS = 'messages.CHAIN_HAS_NOT_SIGNED_OWNER_DOCUMENTS',
  CHAIN_GENERATED_LEGAL_DOCUMENT_NOT_FOUND = 'messages.CHAIN_GENERATED_LEGAL_DOCUMENT_NOT_FOUND',
  CHAIN_GENERATED_DOCUMENTS_MUST_BE_SIGNED = 'messages.CHAIN_GENERATED_DOCUMENTS_MUST_BE_SIGNED',
  CHAIN_SUBSCRIPTION_INACTIVE = 'messages.CHAIN_SUBSCRIPTION_INACTIVE',
  CHAIN_HAS_NO_LEGAL_INFO = 'messages.CHAIN_HAS_NO_LEGAL_INFO',
  TBANK_PAYMENT_CREATION_ERROR = 'messages.TBANK_PAYMENT_CREATION_ERROR',
  TBANK_NO_RECEIPTS_DATA = 'messages.TBANK_NO_RECEIPTS_DATA',
  PROMOCODE_ACTIVATION_FAILED = 'messages.PROMOCODE_ACTIVATION_FAILED',
  ORDERED_ITEM_NOT_WITHIN_DISPLAY_INTERVAL = 'messages.ORDERED_ITEM_NOT_WITHIN_DISPLAY_INTERVAL',
  CLIENT_HAS_NO_PREVIOUS_ORDERS = 'messages.CLIENT_HAS_NO_PREVIOUS_ORDERS',
  ORDER_FOR_ANOTHER_PERSON_NOT_ENABLED = 'messages.ORDER_FOR_ANOTHER_PERSON_NOT_ENABLED',
  PACKAGE_WEIGHT_BELOW_ORDER_POINT_MINIMUM = 'messages.PACKAGE_WEIGHT_BELOW_ORDER_POINT_MINIMUM',
  PACKAGE_WEIGHT_EXCEEDS_ORDER_POINT_MAXIMUM = 'messages.PACKAGE_WEIGHT_EXCEEDS_ORDER_POINT_MAXIMUM',
  ORDER_POINT_HAS_NO_CDEK_CITY_CODE = 'messages.ORDER_POINT_HAS_NO_CDEK_CITY_CODE',
  LOCATION_HAS_NO_CDEK_CITY_CODE = 'messages.LOCATION_HAS_NO_CDEK_CITY_CODE',
  CDEK_TARIFF_NOT_FOUND = 'messages.CDEK_TARIFF_NOT_FOUND',
  ORDER_POINT_NOT_FOUND = 'messages.ORDER_POINT_NOT_FOUND',
  CDEK_NO_TARIFF_AVAILABLE = 'messages.CDEK_NO_TARIFF_AVAILABLE',
  CDEK_UNAVAILABLE_FOR_SCHEDULED_ITEMS = 'messages.CDEK_UNAVAILABLE_FOR_SCHEDULED_ITEMS',
}

// New localized error property keys
export enum ErrorPropertyKey {
  'customerInfo.phone' = 'properties.customerInfo.phone',
  'customerInfo.name' = 'properties.customerInfo.name',
  'customerInfo.address' = 'properties.customerInfo.address',
  'customerInfo.floor' = 'properties.customerInfo.floor',
  'customerInfo.apartment' = 'properties.customerInfo.apartment',
  'customerInfo.entranceway' = 'properties.customerInfo.entranceway',
  'customerInfo.intercom' = 'properties.customerInfo.intercom',
  'customerInfo.point.lat' = 'properties.customerInfo.point.lat',
  'customerInfo.point.lng' = 'properties.customerInfo.point.lng',
  'emailForReceipts' = 'properties.emailForReceipts',
  'paymentType' = 'properties.paymentType',
  'commentary' = 'properties.commentary',
  'locationId' = 'properties.locationId',
  'deliveryZoneId' = 'properties.deliveryZoneId',
  'orderPrice' = 'properties.orderPrice',
  'deliveryInfo' = 'properties.deliveryInfo',
}
